<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{ 'manage.validityModal.title' | translate }}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" (onClick)="onCancel()">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>
<mat-dialog-content class="overflow-hidden">
  <p>{{ 'manage.validityModal.subtitle' | translate }}</p>

  <div class="flex items-center gap-2" *ngIf="data.formInvalid">
    <app-icon fill="#ef4444" iconName="info" size="md"></app-icon>
    <p class="text-red-500 m-0">{{ 'manage.validityModal.resolveErrors' | translate }}</p>
  </div>
</mat-dialog-content>
<div mat-dialog-actions class="flex flex-row justify-between w-full items-center p-6 pt-0">
  <flow-button theme="secondary" variation="outline" (onClick)="onDiscard()">{{ 'global.discard' | translate }}</flow-button>
  <flow-button theme="primary" [disabled]="disable" (onClick)="onSave()">{{ 'global.save' | translate }}</flow-button>
</div>
